import { apiClient } from '../shared/services/api';

export interface StoryAppeal {
  id: string;
  storyId: string;
  storyTitle: string;
  authorId: string;
  reason: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  submittedAt: string;
  reviewedAt?: string;
  adminResponse?: string;
  originalRejectionReason?: string;
}

export interface AppealCreateRequest {
  appealReason: string;
}

export interface AuthorStoryStatus {
  id: string;
  title: string;
  status: 'DRAFT' | 'PENDING_REVIEW' | 'AI_REVIEW_PENDING' | 'ADMIN_REVIEW_PENDING' | 'REJECTED' | 'APPROVED' | 'PUBLISHED';
  submittedAt?: string;
  reviewedAt?: string;
  rejectionReason?: string;
  canAppeal: boolean;
  appealStatus?: 'PENDING' | 'APPROVED' | 'REJECTED';
  aiAnalysis?: {
    confidence: number;
    violations: string[];
    explanation: string;
    appropriate: boolean;
  };
}

export interface ContentGuideline {
  id: string;
  category: string;
  title: string;
  description: string;
  examples: {
    good: string[];
    bad: string[];
  };
  importance: 'HIGH' | 'MEDIUM' | 'LOW';
}

export const storyAppealService = {
  // Get author's stories with their status and appeal eligibility
  getMyStoryStatuses: () =>
    apiClient.get<any[]>('/stories/my'),

  // Submit an appeal for a rejected story
  submitAppeal: (storyId: string, request: AppealCreateRequest) => {
    const endpoint = `/stories/${storyId}/appeal`;
    console.log('APPEAL ENDPOINT:', endpoint, 'Story ID:', storyId);
    return apiClient.post<StoryAppeal>(endpoint, request);
  },

  // Get author's appeals
  getMyAppeals: () =>
    apiClient.get<StoryAppeal[]>('/stories/appeals/my'),

  // Get specific appeal details
  getAppeal: (appealId: string) =>
    apiClient.get<StoryAppeal>(`/stories/appeals/${appealId}`),

  // Get content creation guidelines
  getContentGuidelines: () =>
    apiClient.get<ContentGuideline[]>('/content/guidelines'),

  // Get detailed feedback for a rejected story
  getRejectionDetails: (storyId: string) =>
    apiClient.get<{
      reason: string;
      timestamp: string;
      adminNotes?: string;
      suggestedImprovements?: string[];
      violationCategories?: string[];
    }>(`/stories/${storyId}/rejection-details`),
};

export const appealService = {
  // Admin endpoints for managing appeals
  getPendingAppeals: () =>
    apiClient.get<StoryAppeal[]>('/admin/appeals/pending'),

  reviewAppeal: (appealId: string, decision: 'APPROVED' | 'REJECTED', response: string) =>
    apiClient.post(`/admin/appeals/${appealId}/review`, { decision, response }),

  getAppealStats: () =>
    apiClient.get<{
      totalPending: number;
      totalApproved: number;
      totalRejected: number;
      avgResponseTimeHours: number;
    }>('/admin/appeals/stats'),
};